import { render, staticRenderFns } from "./ModalConversationReportClient.vue?vue&type=template&id=32a44428&scoped=true&"
import script from "./ModalConversationReportClient.vue?vue&type=script&lang=js&"
export * from "./ModalConversationReportClient.vue?vue&type=script&lang=js&"
import style0 from "./ModalConversationReportClient.vue?vue&type=style&index=0&id=32a44428&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a44428",
  null
  
)

export default component.exports